import { ExcaptText } from './FeatureSlidesComponent.style';
import React, { useEffect, useState} from "react";
import {
    ContainerFluid,Container, HeadingText,Cardde
} from './LatestBlogComponent.style';
import {
    useQuery,
} from "@apollo/client";
import { ARTICLE_MANY, ARTICLE_POPULAR } from '../../../../../../GraqhQl/Queries';
import { Link } from 'react-router-dom';

import parse from 'html-react-parser';

export default function LatestBlogComponent() {
   
    const { loading, error, data } = useQuery(ARTICLE_POPULAR,{
        count:100,
    });


    useEffect(() => {
 
        console.log("Data gotten ");
        console.log(data);
 

    }, [data,]);   
    
    if (loading) return  <p className="center">Loading Stories..</p>;
    if (error) return <p className="center">Error loading Stories!</p>;
    return (
        <div>
        <ContainerFluid className='mb-50'>
            <Container>
           
                <div>
                    <div className='row'>
                        <div className='col 12'>
                            <HeadingText>
                                Latest
                            </HeadingText>
                        </div><br/>
                    </div>
                    
                    <div>{data.article_popular && 
                        data.article_popular.length <=0
                        ? <h1>empty</h1>
                        : <div>
                            {data.article_popular.map((val)=>{
                                return <div className='row mb-100' >
                                <Link to={`/blogs/${val._id}`}>
                                <div className="col s12 m12 l4">
                                    <Cardde>
                                        <div className="card  z-depth-0">
                                            <div class="card-image" 
                                                style={{
                                                    backgroundImage:`url(${val.image})`,
                                                    backgroundSize:"100% 100%",
                                                    backgroundRepeat:'no-repeat',
                                                }}
                                            ></div>
                                            
                                        </div>
                                    </Cardde>
                                </div>
                                <div className='col s12 m12 l8'>
                                    <br className=''/>
                                    <div className='col s12'>
                                        <HeadingText>
                                            {val.title}
                                        </HeadingText>
                                    </div>
                                    <div className="card-content p-16">
                                        <ExcaptText>
                                            {parse(val.excerpt) }
                                        </ExcaptText>
                                        <small>{val.createdAt}</small>
                                    </div>
                                </div>
                                </Link>  
                            </div>;
                            })}
                            
                        </div>
                        }
                    </div>
                </div>
            </Container>
        </ContainerFluid>
    </div>

             
  )
}
